import { getConfig } from "../../../utils/config";

/*
--bbButton-color
#465eff
: #465eff;
--bbButton-text-color: #fcfc30;
--border-color: #465eff;
--button-color: #465eff;
--color-link: #465eff;
--icon-color: #465eff;
--nav-bg-color: #fcfc30;
--bbButton-color: #3333BD;
*/

const config = getConfig();

const colors = config.theme.colors;

const primary = colors.primary;
const primaryVariant = colors.primaryVariant;
const secondary = colors.secondary;
const secondaryVariant = colors.secondaryVariant;
const light = colors.light;
const red = colors.red;
const yellow = colors.yellow;
const darkBlue = colors.darkBlue;
const lightBlue = colors.lightBlue;
const lightBlue2 = colors.lightBlue2;
const lightCyan = colors.lightCyan;
const lightDark = colors.lightDark;
const dark = colors.dark;
const danger = colors.danger;
const lightDanger = colors.lightDanger;
const info = colors.info;
const infoVariant = colors.infoVariant;
const success = colors.success;
const successVariant = colors.successVariant;
const warn = colors.warn;
const white = colors.white;

export {
  primary,
  primaryVariant,
  secondary,
  secondaryVariant,
  light,
  red,
  yellow,
  darkBlue,
  lightBlue,
  lightBlue2,
  lightCyan,
  lightDark,
  dark,
  danger,
  lightDanger,
  info,
  infoVariant,
  success,
  successVariant,
  warn,
  white,
};



// WEBPACK FOOTER //
// ./src/assets/_base/colors/index.js